import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { type SwitchProps } from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import { useClientTheme } from 'utils/clientTheme';

interface Props extends SwitchProps {}
const StyledSwitchButton = ({ ...props }: Props) => {
  const { enableDarkTheme } = useAppTheme();
  const palette = useClientTheme();
  return (
    <CustomSwitch
      {...props}
      enableDarkTheme={enableDarkTheme}
      primaryColor={palette.primary}
    />
  );
};

interface CustomSwitchProps extends SwitchProps {
  enableDarkTheme: boolean;
  primaryColor: string;
}
const CustomSwitch = styled(Switch)<CustomSwitchProps>(({ primaryColor }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
    background: 'white',
    '&.Mui-disabled': {
      background: '#023059',
    },
  },
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      '& + .MuiSwitch-track': {
        backgroundColor: primaryColor,
        opacity: 1,
      },
    },
    '&.Mui-disabled': {
      '& + .MuiSwitch-track': {
        opacity: 0.3,
      },
    },
  },
}));

export default StyledSwitchButton;
